/* eslint-disable no-template-curly-in-string */
import { Button, MuiThemeProvider } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { getGenericCardButtonTheme } from '../../config/themes/genericCardButtonTheme';
import {
  ESCOLA_STATUS_ATIVADA,
  ESCOLA_STATUS_DESATIVADA,
} from '../../library/EscolaStatus';
import {
  createEscolaRoute,
  escolaEditRoute,
  idebRoute,
} from '../../library/Routes';
import { changeEscolaStatus, deleteEscola, setCurrentTab, clearEscolasPageList, resetProgramaValue } from '../../store/modules/EscolasActions';
import { getFormattedPhone } from '../../utils/DataFormatUtils';
import {
  getElementID,
  getMergedClassNames,
  getPositionByTarget,
} from '../../utils/HTMLUtils';
import { capitalizeFirstLetterOfTheWord } from '../../utils/TextUtils';
import { Col } from '../Col';
import PhoneIcon from '../Icons/PhoneIcon';
import RefreshIcon from '../Icons/RefreshIcon';
import chartBarIcon from './../../assets/images/svg/chart-bar-icon.svg';
import dadosDaEscolaIcon from './../../assets/images/svg/dados-da-escola-icon.svg';
import editIcon from './../../assets/images/svg/edit-icon.svg';
import editAlertIcon from './../../assets/images/svg/edit-alert-icon.svg';
import mapPointBlackIcon from './../../assets/images/svg/map-point-black-icon.svg';
import professorActivateIcon from './../../assets/images/svg/professor-activate-icon.svg';
import professorRemoveIcon from './../../assets/images/svg/professor-remove-icon.svg';
import schoolBlackIcon from './../../assets/images/svg/school-black-icon.svg';
import TooltipCaller from './../TooltipManager/TooltipCaller';
import styles from './EscolaItem.scss';
import { hasCadastroPendente } from 'contexts/alert/AlertApi';
import { getApis } from 'library/Apis';
import { toRequest } from 'utils/RequestUtils';
import api from 'services/api';
import { openModal } from 'store/modules/ModalActions';
import { EscolaEditTabs } from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__enum';
import LayoutModal from 'components/LayoutModal';
import LixeiraIcon from 'assets/icons/LixeiraIcon';

const rootClassName = styles.rootClassName;
class EscolaItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusChanging: false,
      nowrapCardPositions: {},
    };

    this.openEscola = this.openEscola.bind(this);
    this.openDadosEscola = this.openDadosEscola.bind(this);
    this.openIdeb = this.openIdeb.bind(this);
    this.toggleStatus = this.toggleStatus.bind(this);
    this.mouseEnter = this.mouseEnter.bind(this);
  }

  getStatus() {
    return this.props.escola.status;
  }

  disabledEditButton() {
    return this.getStatus() === ESCOLA_STATUS_DESATIVADA ? true : false;
  }

  disabledActivateButton() {
    return false;
  }

  getEndpoint = (version) => {
    return getApis().apis.backofficeProjetos + 'v' + version + '/escola';
  };

  getProgramasVerify(idEscola) {
    return toRequest(api.get, [this.getEndpoint(1) + `/programas/${idEscola}`], 'programas')
      .then((response) => {
        this.programasData = response.data;
        return response.data;
      })
      .then((data) => data)
      .catch((error) => {
        console.error(error);
      });
  }

  openIdeb() {
    const larguraDaTela = window.innerWidth;
    if (larguraDaTela >= 768) {
      window.open(idebRoute.getURLWithParams(this.props.escola.id), '_blank');
    } else {
      this.props.history.push(idebRoute.getURLWithParams(this.props.escola.id));
    }
  }

  openDadosEscola() {
    const larguraDaTela = window.innerWidth;
    this.getProgramasVerify(this.props.escola.id)
      .then((programasData) => {
        if (programasData.length > 0) {
          if (larguraDaTela >= 768 && !this.props.escola.cadastroPendente) {
            window.open(
              escolaEditRoute.getURLWithParams(this.props.escola.id, EscolaEditTabs.ProgramasEducacionais), '_blank'
            );
          } else {
            this.props.history.push(
              escolaEditRoute.getURLWithParams(this.props.escola.id, EscolaEditTabs.ProgramasEducacionais)
            );
          }
        } else {
          this.props.history.push(
            createEscolaRoute.getURLWithParams(this.props.escola.id, EscolaEditTabs.Informacoes)
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  openEscola() {
    if (!this.props.escola.cadastroPendente) {
      this.props.history.push(
        escolaEditRoute.getURLWithParams(this.props.escola.id)
      );
    } else {
      this.props.resetProgramaValue();
      this.props.history.push(
        createEscolaRoute.getURLWithParams(this.props.escola.id, EscolaEditTabs.Informacoes)
      );
    }
    localStorage.removeItem('assessorPrograma');
  }

  async toggleStatus() {
    this.setState({
      ...this.state,
      statusChanging: true,
    });
    await hasCadastroPendente();
    const newStatus =
      this.props.escola.status === ESCOLA_STATUS_DESATIVADA
        ? ESCOLA_STATUS_ATIVADA
        : ESCOLA_STATUS_DESATIVADA;
    this.props.changeEscolaStatus(
      this.props.escola.id,
      newStatus,
      () => {
        this.setState({
          ...this.state,
          statusChanging: false,
        });
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroAlterarStatusEscola,
          options: {
            variant: 'error',
          },
        });
        this.setState({
          ...this.state,
          statusChanging: false,
        });
      }
    );
  }

  allowDadosEscolaButton() {
    return this.props.auth.userPermissions.escolas.dadosDaEscola.list
      ? true
      : false;
  }

  allowIdebButton() {
    return this.props.auth.userPermissions.escolas.ideb.list ? true : false;
  }

  allowEditButton() {
    return this.props.auth.userPermissions.escolas.edit ? true : false;
  }

  allowActivateOrDeactivateButton() {
    if (this.getStatus() === ESCOLA_STATUS_DESATIVADA) {
      // toActivate
      return this.props.auth.userPermissions.escolas.activate ? true : false;
    } else {
      // toDeactivate
      return this.props.auth.userPermissions.escolas.deactivate ? true : false;
    }
  }

  disabledDelete() {
    const enableButton = this.props.escola.hasRelacionamento;
    return enableButton;
  }

  showDelete() {
    return this.props.escola.exibirExclusao;
  }

  totalAllowedActionButtons() {
    let allowedButtons = 0;
    if (this.allowDadosEscolaButton()) {
      allowedButtons++;
    }
    if (this.allowIdebButton()) {
      allowedButtons++;
    }
    if (this.allowEditButton()) {
      allowedButtons++;
    }
    if (this.allowActivateOrDeactivateButton()) {
      allowedButtons++;
    }
    return allowedButtons;
  }

  getCardButton(props) {
    return (
      <Button
        variant='contained'
        color='primary'
        {...props}
        className={getMergedClassNames([
          rootClassName + '-card-item',
          !this.allowEditButton() ? rootClassName + '-not-allowed' : '',
          props && props.className ? props.className : '',
        ])}
        onClick={(e) => {
          if (this.allowEditButton()) {
            this.openEscola();
          }
          if (props && typeof props.onClick === 'function') {
            props.onClick(e);
          }
        }}
        disabled={this.state.statusChanging || this.disabledEditButton()}
      >
        <p
          className={rootClassName + '-label ' + rootClassName + '-label-name'}
        >
          <img
            className={rootClassName + '-label-icon'}
            src={schoolBlackIcon}
            alt='icone-label'
            loading='lazy'
          />
          {capitalizeFirstLetterOfTheWord(this.props.escola.nomeFantasia)}
        </p>
        <p
          className={
            rootClassName + '-label ' + rootClassName + '-label-telefone'
          }
        >
          <PhoneIcon className={rootClassName + '-label-icon'} />
          {getFormattedPhone(this.props.escola.telefone)}
        </p>
        <p
          className={
            rootClassName + '-label ' + rootClassName + '-label-cidade'
          }
        >
          <img
            className={rootClassName + '-label-icon'}
            src={mapPointBlackIcon}
            alt='icone-label'
            loading='lazy'
          />
          {this.props.escola.cidade}
        </p>
      </Button>
    );
  }

  confirmaRemover = () => {
    this.props.openModal(LayoutModal, {
      title: 'Deletar',
      content: <Fragment>Você tem certeza que deseja <strong>deletar essa escola</strong>? Essa ação é irreversível.</Fragment>,
      confirmLabel: 'Deletar',
      cancelLabel: 'Cancelar',
      confirmThemeButton: 'button_PUFV',
      cancelThemeButton: 'button_PUFV',
      confirmCallback: () => {
        deleteEscola(
          this.props.escola.id,
          () => {
            SnackbarUtils.enqueueSnackbar({
              message: 'Registro excluído com sucesso!',
              options: { variant: 'success' },
            });
            this.props.savedCallback()
          }, (error) => {
            SnackbarUtils.enqueueSnackbar({
              message: error.response.statusText,
              options: { variant: 'error' },
            });
          }
        )();
      },
    })
  };

  mouseEnter(e) {
    this.setState({
      ...this.state,
      nowrapCardPositions: getPositionByTarget(e.currentTarget),
    });
  }

  render() {
    return (
      <Col className={rootClassName + '-col'} cols={[12, 6, 4, 3, 2]}>
        <div className={rootClassName}>
          <div
            className={rootClassName + '-card-container'}
            onMouseEnter={this.mouseEnter}
          >
            <MuiThemeProvider theme={getGenericCardButtonTheme('pufvYellow')}>
              {this.getCardButton({
                id: getElementID(this.props.id, 'principal-edit'),
              })}
              {this.getCardButton({
                id: getElementID(this.props.id, 'principal-hover-edit'),
                className: getMergedClassNames([
                  rootClassName + '-card-item-with-wrap',
                  this.state.nowrapCardPositions.top
                    ? rootClassName + '-card-item-with-wrap-top'
                    : '',
                  this.state.nowrapCardPositions.bottom
                    ? rootClassName + '-card-item-with-wrap-bottom'
                    : '',
                  this.state.nowrapCardPositions.left
                    ? rootClassName + '-card-item-with-wrap-left'
                    : '',
                  this.state.nowrapCardPositions.right
                    ? rootClassName + '-card-item-with-wrap-right'
                    : '',
                ]),
              })}
            </MuiThemeProvider>
          </div>
          <div
            className={
              rootClassName +
              '-action-buttons ' +
              rootClassName +
              '-allowed-' +
              this.totalAllowedActionButtons() +
              '-action-buttons'
            }
          >
            <div className={rootClassName + '-action-buttons-mirror'}>
              {this.allowDadosEscolaButton() ? (
                <div
                  className={
                    rootClassName +
                    '-action-button-mirror ' +
                    (this.state.statusChanging || this.disabledEditButton()
                      ? rootClassName + '-action-button-mirror-disabled'
                      : '')
                  }
                ></div>
              ) : null}
              {this.allowIdebButton() ? (
                <div
                  className={
                    rootClassName +
                    '-action-button-mirror ' +
                    (this.state.statusChanging || this.disabledEditButton()
                      ? rootClassName + '-action-button-mirror-disabled'
                      : '')
                  }
                ></div>
              ) : null}
              {this.allowEditButton() ? (
                <div
                  className={
                    rootClassName +
                    '-action-button-mirror ' +
                    (this.state.statusChanging || this.disabledEditButton()
                      ? rootClassName + '-action-button-mirror-disabled'
                      : '')
                  }
                ></div>
              ) : null}
              {this.allowActivateOrDeactivateButton() ? (
                <div
                  className={
                    rootClassName +
                    '-action-button-mirror ' +
                    (this.state.statusChanging || this.disabledActivateButton()
                      ? rootClassName + '-action-button-mirror-disabled'
                      : '')
                  }
                ></div>
              ) : null}
            </div>
            {this.allowDadosEscolaButton() ? (
              <TooltipCaller
                text={this.props.languageValues.openDadosEscolaHint
                  .split('${1}')
                  .join(
                    '"' +
                    capitalizeFirstLetterOfTheWord(
                      this.props.escola.nomeFantasia
                    ) +
                    '"'
                  )}
              >
                <button
                  id={getElementID(this.props.id, 'dados-da-escola')}
                  disabled={
                    this.state.statusChanging || this.disabledEditButton()
                  }
                  className={rootClassName + '-action-button'}
                  onClick={this.openDadosEscola}
                >
                  <img
                    src={dadosDaEscolaIcon}
                    alt='icone-dados-escola'
                    loading='lazy'
                    className={rootClassName + '-grey-icon'}
                  />
                </button>
              </TooltipCaller>
            ) : null}
            {this.allowIdebButton() ? (
              <TooltipCaller
                text={this.props.languageValues.openIdebHint
                  .split('${1}')
                  .join(
                    '"' +
                    capitalizeFirstLetterOfTheWord(
                      this.props.escola.nomeFantasia
                    ) +
                    '"'
                  )}
              >
                <button
                  id={getElementID(this.props.id, 'ideb')}
                  disabled={
                    this.state.statusChanging || this.disabledEditButton()
                  }
                  className={rootClassName + '-action-button'}
                  onClick={this.openIdeb}
                >
                  <img
                    src={chartBarIcon}
                    alt='icone-grafico'
                    loading='lazy'
                    className={rootClassName + '-grey-icon'}
                  />
                </button>
              </TooltipCaller>
            ) : null}
            {this.allowEditButton() ? (
              <TooltipCaller
                text={this.props.languageValues.editEscolaHint
                  .split('${1}')
                  .join(
                    '"' +
                    capitalizeFirstLetterOfTheWord(
                      this.props.escola.nomeFantasia
                    ) +
                    '"'
                  )}
              >
                <button
                  id={getElementID(this.props.id, 'edit')}
                  disabled={
                    this.state.statusChanging || this.disabledEditButton()
                  }
                  className={rootClassName + '-action-button'}
                  onClick={this.openEscola}
                >
                  {this.props.escola.cadastroPendente ? (
                    <img
                      src={editAlertIcon}
                      alt='icone-alerta-editar'
                      loading='lazy'
                      className={rootClassName + '-grey-icon'}
                    />
                  ) : (
                    <img
                      src={editIcon}
                      alt='icone-editar'
                      loading='lazy'
                      className={rootClassName + '-grey-icon'}
                    />
                  )}
                </button>
              </TooltipCaller>
            ) : null}
            {this.allowActivateOrDeactivateButton() ? (
              <TooltipCaller
                text={
                  this.getStatus() === ESCOLA_STATUS_DESATIVADA
                    ? this.props.languageValues.activateEscolaHint
                      .split('${1}')
                      .join(
                        '"' +
                        capitalizeFirstLetterOfTheWord(
                          this.props.escola.nomeFantasia
                        ) +
                        '"'
                      )
                    : this.props.languageValues.deactivateEscolaHint
                      .split('${1}')
                      .join(
                        '"' +
                        capitalizeFirstLetterOfTheWord(
                          this.props.escola.nomeFantasia
                        ) +
                        '"'
                      )
                }
              >
                <button
                  id={getElementID(
                    this.props.id,
                    this.getStatus() === ESCOLA_STATUS_DESATIVADA
                      ? 'activate'
                      : 'deactivate'
                  )}
                  disabled={
                    this.state.statusChanging || this.disabledActivateButton()
                  }
                  className={rootClassName + '-action-button'}
                  onClick={this.toggleStatus}
                >
                  {this.state.statusChanging ? (
                    <RefreshIcon className={rootClassName + '-refresh-icon'} />
                  ) : (
                    <img
                      src={
                        this.getStatus() === ESCOLA_STATUS_DESATIVADA
                          ? professorActivateIcon
                          : professorRemoveIcon
                      }
                      alt='icone-ativar/desativar'
                      loading='lazy'
                      className={rootClassName + '-grey-icon'}
                    />
                  )}
                </button>
              </TooltipCaller>
            ) : null}
            {this.showDelete()
              &&
            <TooltipCaller
            text={this.disabledDelete()
              ? 'Para excluir, é necessário não haver contratos ou projetos vinculados a essa escola.'
              : ''}
            >
              <button
                id={getElementID(this.props.id, 'delete')}
                disabled={this.state.statusChanging || this.disabledEditButton() || this.disabledDelete()}
                className={rootClassName + '-action-button'}
                onClick={() => this.confirmaRemover()}
              >
                {this.state.statusChanging ? (
                  <RefreshIcon className={rootClassName + '-refresh-icon'} />
                ) : (
                  this.getStatus() === ESCOLA_STATUS_DESATIVADA ? (
                    <LixeiraIcon className={rootClassName + '-grey-icon'} />
                  ) : (
                    <LixeiraIcon />
                  )
                )}
              </button>
            </TooltipCaller>}
          </div>
        </div>
      </Col>
    );
  }
}

EscolaItem.propTypes = {
  id: PropTypes.string,
  key: PropTypes.number,
  escola: PropTypes.object,
  savedCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeEscolaStatus,
      setCurrentTab,
      openModal,
      resetProgramaValue,
      clearEscolasPageList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EscolaItem));
